import React from 'react';
import classnames from 'classnames';

const Heading = ({ children, className, level = 1, ...props }) => {
  switch (level) {
    case 1:
    default:
      return (
        <h1
          className={classnames(
            className,
            'font-bold text-3xl md:text-4xl lg:text-5xl leading-snug mt-12'
          )}
          {...props}
        >
          {children}
        </h1>
      );
    case 2:
      return (
        <h2
          className={classnames(
            className,
            'font-bold text-2xl md:text-3xl lg:text-4xl leading-snug mt-12'
          )}
          {...props}
        >
          {children}
        </h2>
      );
    case 3:
      return (
        <h3
          className={classnames(
            className,
            'font-bold text-xl md:text-2xl lg:text-3xl leading-snug mt-12'
          )}
          {...props}
        >
          {children}
        </h3>
      );
    case 4:
      return (
        <h4
          className={classnames(
            className,
            'font-bold text-lg md:text-xl lg:text-2xl leading-snug mt-12'
          )}
          {...props}
        >
          {children}
        </h4>
      );
    case 5:
      return (
        <h5
          className={classnames(
            className,
            'font-bold text-base md:text-lg lg:text-xl leading-snug mt-12'
          )}
          {...props}
        >
          {children}
        </h5>
      );
  }
};

export default Heading;
